import React from 'react'

function SuppportStaffDetail() {
    return (
        <div>

        </div>
    )
}

export default SuppportStaffDetail
